function initSortDropdown() {
  var trigger = document.querySelector('.mobile-sort-trigger');
  var menu = document.querySelector('.mobile-sort-menu');
  var hiddenSelect = document.querySelector('.mobile-sort-hidden-select');
  if (!trigger || !menu || !hiddenSelect) return;

  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (menu.hidden) {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
  });

  menu.querySelectorAll('.mobile-sort-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var value = opt.getAttribute('data-value');
      menu.querySelectorAll('.mobile-sort-option').forEach(function(o) {
        o.classList.remove('is-selected');
      });
      opt.classList.add('is-selected');
      hiddenSelect.value = value;
      hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function(e) {
    if (!menu.contains(e.target) && !trigger.contains(e.target)) {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSortDropdown);
} else {
  initSortDropdown();
}